const GLYPHS = {
  process: (
    <g>
      <path
        d="M4 28h9V10h12v24h11"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.2"
        className="glyph-flow"
      />
      <rect x="2" y="26" width="4" height="4" className="glyph-node" />
      <rect x="23" y="8" width="4" height="4" className="glyph-node" />
      <rect x="36" y="30" width="4" height="4" className="glyph-node-hot glyph-pulse" />
    </g>
  ),
  people: (
    <g>
      {[
        [20, 5],
        [35, 20],
        [20, 35],
        [5, 20],
      ].map(([x, y], i) => (
        <g key={i}>
          <line x1="20" y1="20" x2={x} y2={y} stroke="currentColor" strokeWidth="1" opacity="0.45" />
          <circle cx={x} cy={y} r="2.6" className="glyph-node" />
        </g>
      ))}
      <circle cx="20" cy="20" r="4.2" className="glyph-node-hot glyph-pulse" />
    </g>
  ),
  technology: (
    <g>
      <rect x="6" y="7" width="28" height="5.5" fill="none" stroke="currentColor" strokeWidth="1" opacity="0.5" />
      <rect x="6" y="17.25" width="28" height="5.5" fill="none" stroke="#38BDF8" strokeWidth="1.2" className="glyph-flow" />
      <rect x="6" y="27.5" width="28" height="5.5" fill="none" stroke="currentColor" strokeWidth="1" opacity="0.5" />
    </g>
  ),
  governance: (
    <g>
      {[0, 1, 2].map((r) =>
        [0, 1, 2].map((c) => (
          <rect
            key={`${r}-${c}`}
            x={6 + c * 10.5}
            y={6 + r * 10.5}
            width="6.5"
            height="6.5"
            fill="none"
            stroke="currentColor"
            strokeWidth="1"
            opacity="0.5"
          />
        ))
      )}
      <rect x="4" y="4" width="10.5" height="10.5" fill="none" stroke="#38BDF8" strokeWidth="1.2" className="glyph-pulse" />
    </g>
  ),
  ai: (
    <g>
      <path
        d="M8 20h8m0 0 10-11M16 20h18M16 20l10 11"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.2"
        className="glyph-flow"
      />
      <circle cx="6" cy="20" r="3" className="glyph-node-hot glyph-pulse" />
      <circle cx="36" cy="7" r="2.4" className="glyph-node" />
      <circle cx="36" cy="20" r="2.4" className="glyph-node" />
      <circle cx="36" cy="33" r="2.4" className="glyph-node" />
    </g>
  ),
};

export default function AreaGlyph({ type, className = "h-10 w-10 text-slate-500" }) {
  return (
    <svg viewBox="0 0 40 40" className={className} aria-hidden="true" focusable="false">
      {GLYPHS[type]}
    </svg>
  );
}
